import { RootState } from "../../../../../redux/store";

export const vehicleSubcategoriesLoading = (state: RootState) => state.vehicleSubcategories.itemsLoading;
export const vehicleSubcategoryActionLoading = (state: RootState) => state.vehicleSubcategories.actionsLoading;
export const dropDownLoading = (state: RootState) => state.vehicleSubcategories.dropDownLoading;

export const vehicleSubcategories = (state: RootState) => state.vehicleSubcategories.items;
export const vehicleSubcategoriesCount = (state: RootState) => state.vehicleSubcategories.itemsCount;
export const vehicleSubcategoryForEdit = (state: RootState) => state.vehicleSubcategories.itemForEdit;
export const dropDownValues = (state: RootState) => state.vehicleSubcategories.dropDownItems;

export const error = (state: RootState) => state.vehicleSubcategories.error;
export const errorAction = (state: RootState) => state.vehicleSubcategories.errorAction;
export const dropDownError = (state: RootState) => state.vehicleSubcategories.dropDownError;

export const validationErrors = (state: RootState) => state.vehicleSubcategories.validationErrors;

export const filters = (state: RootState) => state.vehicleSubcategories.filters;
